import React, {useEffect, useRef, useState} from "react"
import Footer from "./footer"
import Navbar from "./navbar"
import MobileNavbar from "./mobile-navbar"
import {Script} from "gatsby"
import {globalHistory} from '@reach/router'

const Layout = ({data, as, children, pageContext}) => {
    const [load, setLoad] = useState(false);
    const [jQueryLoaded, setJQueryLoaded] = useState(false);
    const [bootstrapiLoaded, setBootstrapiLoaded] = useState(false);

    globalHistory.listen(({action}) => {
        if (action === 'PUSH') {
            setTimeout(() => {
                $(window).trigger('load');
            }, 500);
        }
    });

    useEffect(() => {
        setLoad(true);
        setTimeout(() => {
            setJQueryLoaded(true);
        }, 500);
    }, []);

    return (
        <>
            <div className="preloader">
                <img
                    src="/assets/images/loader.png"
                    className="preloader__image"
                    alt="preloader"
                />
            </div>
            {as === "letter" && (
                <>
                    <div className={`page-wrapper letter p-0`}>{children}</div>

                    {load && (<Script
                        src="/assets/js/jquery.min.js"
                        onLoad={() => setJQueryLoaded(true)}
                    />)}
                    {jQueryLoaded && (
                        <Script
                            src="/assets/js/bootstrap.bundle.min.js"
                            onLoad={() => setBootstrapiLoaded(true)}
                        />
                    )}
                    {jQueryLoaded && bootstrapiLoaded && (
                        <>
                            <Script src="/assets/js/theme.js"></Script>
                            <Script src="/assets/js/custom.js"></Script>
                        </>
                    )}
                </>
            )}
            {as !== "letter" && (
                <>
                    <Navbar as={as} pageContext={pageContext}></Navbar>
                    <div className={`page-wrapper ${as !== "home" ? "pt-10" : ""}`}>
                        {children}
                    </div>
                    <a
                        href="#"
                        data-target="html"
                        className="scroll-to-target scroll-to-top"
                    >
                        <i className="fa fa-angle-up"></i>
                    </a>
                    <MobileNavbar></MobileNavbar>
                    <Footer></Footer>
                    {load && (<Script
                        src="/assets/js/jquery.min.js"
                        onLoad={() => setJQueryLoaded(true)}
                    />)}
                    {jQueryLoaded && (
                        <Script
                            src="/assets/js/bootstrap.bundle.min.js"
                            onLoad={() => setBootstrapiLoaded(true)}
                        />
                    )}
                    {jQueryLoaded && bootstrapiLoaded && (
                        <>
                            <Script src="/assets/js/owl.carousel.min.js"></Script>
                            <Script src="/assets/js/waypoints.min.js"></Script>
                            <Script src="/assets/js/jquery.counterup.min.js"></Script>
                            <Script src="/assets/js/TweenMax.min.js"></Script>
                            <Script src="/assets/js/wow.js"></Script>
                            <Script src="/assets/js/jquery.magnific-popup.min.js"></Script>
                            <Script src="/assets/js/jquery.ajaxchimp.min.js"></Script>
                            <Script src="/assets/js/swiper.min.js"></Script>
                            <Script src="/assets/js/typed-2.0.11.js"></Script>
                            <Script src="/assets/vegas/vegas.js"></Script>
                            <Script src="/assets/js/jquery.validate.min.js"></Script>
                            <Script src="/assets/js/bootstrap-select.min.js"></Script>
                            <Script src="/assets/js/countdown.min.js"></Script>
                            <Script src="/assets/js/jquery.mCustomScrollbar.concat.min.js"></Script>
                            <Script src="/assets/js/bootstrap-datepicker.min.js"></Script>
                            <Script src="/assets/js/nouislider.min.js"></Script>
                            <Script src="/assets/js/isotope.js"></Script>
                            <Script src="/assets/js/theme.js"></Script>
                            <Script src="/assets/js/custom.js"></Script>
                        </>
                    )}
                </>
            )}
        </>
    )
}

export default Layout
